import { useRef, useInsertionEffect, useCallback } from 'react';

// The useEffectEvent API has not yet been added to React,
// so this is a temporary shim
// More information https://react.dev/learn/separating-events-from-effects#declaring-an-effect-event
export function useEffectEvent<
  TParams extends any[],
  TReturn extends void,
  TFunction extends ((...args: TParams) => TReturn) | undefined,
>(fn: TFunction): NonNullable<TFunction> {
  const ref = useRef<typeof fn | null>(null);

  useInsertionEffect(() => {
    ref.current = fn;
  }, [fn]);

  // TODO: Fix the types
  // @ts-ignore
  return useCallback((...args: TParams) => {
    const f = ref.current;
    if (!f) return;

    return f(...args);
  }, []);
}
